export const DATA = [
  {
    day: "Mar 17",
    cashOut: 192,
    cashIn: 812,
  },
  {
    day: "Apr 17",
    cashOut: 220,
    cashIn: 120,
  },
  {
    day: "May 17",
    cashOut: 492,
    cashIn: 612,
  },
  {
    day: "Jun 17",
    cashOut: 92,
    cashIn: 212,
  },
  {
    day: "Jul 17",
    cashOut: 492,
    cashIn: 1412,
  },
  {
    day: "Aug 17",
    cashOut: 192,
    cashIn: 112,
  },
  {
    day: "Sep 17",
    cashOut: 192,
    cashIn: 412,
  },
];

export const CARD_DATA = [
  {
    id: "487ffd90-ac42-4e0c-a2a5-44961834de5e",
    title: "Sales Invoice",
    time: "This Year",
  },
  {
    id: "0dadb98e-c013-4791-bdbb-216c03746992",
    title: "Purchase Invoice",
    time: "This Year",
  },
  {
    id: "5f0329be-1876-47dd-9ddd-1d25a584ebba",
    title: "Profit and Loss",
    time: "This Year",
  },
  {
    id: "8e947fa3-3b47-4ec3-ab4c-7d3ff4e90ccf",
    title: "Top Expenses",
    time: "This Year",
  },
];
